exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.global-announcement-banner[data-v-145ff5ba] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  text-align: center;\n  padding: 10px 20px;\n  font-size: 16px;\n  font-weight: 600;\n  z-index: 9999;\n}\n.global-announcement-text[data-v-145ff5ba] {\n  vertical-align: middle;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-145ff5ba","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/GlobalAnnouncement.vue
// module id = zgdE
// module chunks = 1